module.exports = __webpack_public_path__ + "img/74.90be6d67.jpg";